const FAQs = [
    {
        question: "What are Bubblery Rewards?",
        answer: "Bubblery Rewards is our loyalty program designed to reward our valued customers with exclusive perks, discounts, and special treats."
    },
    {
        question: "How do I join Bubblery Rewards?",
        answer: "Joining Bubblery Rewards is easy! Simply sign up for an account on our website or at any of our Bubblery locations."
    },
    {
        question: "How do I earn points?",
        answer: "You can earn points by making purchases at Bubblery locations or online. Every dollar spent earns you points towards exciting rewards!"
    },
    {
        question: "What rewards can I redeem with my points?",
        answer: "You can redeem your points for a variety of rewards, including free drinks, discounts on future purchases, and special promotions."
    },
    {
        question: "Do my points expire?",
        answer: "No, your points do not expire, so you can save them up for bigger rewards or redeem them whenever you'd like."
    },
    {
        question: "Can I earn points on gift card purchases?",
        answer: "Yes, you can earn points on purchases made with Bubblery Gift Cards, so you can enjoy rewards while giving the gift of Bubblery to others."
    },
    {
        question: "How can I check my points balance?",
        answer: "You can easily check your points balance online by logging into your Bubblery account or by asking one of our friendly staff members at any Bubblery location."
    },
    {
        question: "Can I combine points from multiple accounts?",
        answer: "No, points cannot be combined from multiple accounts. Points are tied to individual accounts and cannot be transferred or combined."
    },
    {
        question: "Is there a membership fee for Bubblery Rewards?",
        answer: "No, Bubblery Rewards is completely free to join! Simply sign up and start earning points with every purchase."
    },
    {
        question: "Can I use my rewards at any Bubblery location?",
        answer: "Yes, you can redeem your rewards at any of our Bubblery locations, so you can enjoy your favorite treats wherever you go!"
    }
]


export default FAQs;